import customMd from './custom-md.md'

export default { customMd }
